import PropTypes from 'prop-types'
import { useEffect } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Button from '@/components/Button'
import Card from '@/components/Card'
import FeatureToggle from '@/components/FeatureToggle'
import { Copy, Plus } from '@/components/Icons'
import KeyValue from '@/components/KeyValue'
import Page from '@/components/Page'
import { AUDIT_API } from '@/constants/featureToggles'
import { isRequestPending } from '@/store/selectors'

import { addAuditConnector, clearClientSecret, deleteAuditConnector, getAuditConnectors } from './actions'
import { ADD_AUDIT_CONNECTOR, GET_AUDIT_CONNECTOR, REMOVE_AUDIT_CONNECTOR } from './actionTypes'
import messages from './messages'
import { getAuditConnector } from './selectors'

import './index.scss'

import { useHistory, useLocation } from 'react-router-dom'

function OrganizationAuditConnectorPage(props: any) {
  const history = useHistory()
  const location = useLocation()

  // componentDidMount
  useEffect(() => {
    props.actions.getAuditConnectors()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // componentWillUnmount
  useEffect(() => {
    return () => {
      props.auditConnector && props.actions.clearClientSecret(props.auditConnector.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const goBack = () => {
    history.push(location.pathname.slice(0, Math.max(0, location.pathname.lastIndexOf('/'))))
  }

  const onDelete = () => {
    props.actions.deleteAuditConnector(props.auditConnector.id)
  }

  const { actions, auditConnector, isAddInProgress, isDeleteInProgress, isLoading } = props
  return (
    <Page>
      <FeatureToggle feature={AUDIT_API} showComingSoon>
        <Page.Header
          title={<FormattedMessage {...messages.pageTitle} />}
          goBack={goBack}
          backNavTitle={<FormattedMessage {...messages.back} />}
        />
        <Card
          className="audit-connector-wrapper"
          isActionInProgress={isAddInProgress || isDeleteInProgress || isLoading}
        >
          <Card.Content>
            {auditConnector ? (
              <div>
                <div>
                  <KeyValue>
                    <KeyValue.Label>
                      <FormattedMessage {...messages.clientId} />
                    </KeyValue.Label>
                    <KeyValue.Value className="copy_icon">{auditConnector.clientCredential.clientId}</KeyValue.Value>
                    <CopyToClipboard text={auditConnector.clientCredential.clientId}>
                      <div className="copy-to-clipboard">
                        <Copy /> <FormattedMessage {...messages.copy} />
                      </div>
                    </CopyToClipboard>
                  </KeyValue>
                </div>
                <div>
                  {auditConnector.clientCredential.clientSecret && (
                    <KeyValue>
                      <KeyValue.Label>
                        <FormattedMessage {...messages.secret} />{' '}
                        <span className="warning">
                          <FormattedMessage {...messages.onlyDisplayedOnce} />
                        </span>
                      </KeyValue.Label>
                      <KeyValue.Value className="copy_icon">
                        {auditConnector.clientCredential.clientSecret}
                      </KeyValue.Value>
                      <CopyToClipboard text={auditConnector.clientCredential.clientSecret}>
                        <div className="copy-to-clipboard">
                          <Copy /> <FormattedMessage {...messages.copy} />
                        </div>
                      </CopyToClipboard>
                    </KeyValue>
                  )}
                </div>
              </div>
            ) : (
              <p>
                <FormattedMessage {...messages.description} />
              </p>
            )}
          </Card.Content>
          <Card.Footer>
            {auditConnector ? (
              <div style={{ float: 'right' }}>
                <Button color="secondary" onClick={onDelete} className="no-right-margin">
                  <FormattedMessage {...messages.reset} />
                </Button>
              </div>
            ) : (
              <div style={{ float: 'right' }}>
                <Button color="primary" onClick={actions.addAuditConnector}>
                  <>
                    {' '}
                    <Plus />
                    <FormattedMessage {...messages.create} />
                  </>
                </Button>
              </div>
            )}
          </Card.Footer>
        </Card>
      </FeatureToggle>
    </Page>
  )
}

OrganizationAuditConnectorPage.displayName = 'OrganizationAuditConnectorPage'

OrganizationAuditConnectorPage.propTypes = {
  actions: PropTypes.shape({
    getAuditConnectors: PropTypes.func.isRequired,
    addAuditConnector: PropTypes.func.isRequired,
    deleteAuditConnector: PropTypes.func.isRequired
  }).isRequired,
  auditConnector: PropTypes.shape({
    clientCredential: PropTypes.shape({
      clientId: PropTypes.string,
      clientSecret: PropTypes.string
    }),
    id: PropTypes.string,
    type: PropTypes.string
  }),
  isLoading: PropTypes.bool.isRequired,
  isAddInProgress: PropTypes.bool.isRequired,
  isDeleteInProgress: PropTypes.bool.isRequired
}

OrganizationAuditConnectorPage.defaultProps = {
  auditConnector: null
}

export { /** @deprecated */ OrganizationAuditConnectorPage }

function mapStateToProps(state: any) {
  return {
    auditConnector: getAuditConnector(state),
    isLoading: isRequestPending(state, GET_AUDIT_CONNECTOR),
    isAddInProgress: isRequestPending(state, ADD_AUDIT_CONNECTOR),
    isDeleteInProgress: isRequestPending(state, REMOVE_AUDIT_CONNECTOR)
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    actions: bindActionCreators(
      { addAuditConnector, getAuditConnectors, deleteAuditConnector, clearClientSecret },
      dispatch
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationAuditConnectorPage)
